import {
  InProductTrialsOverlayWindowGroupId,
  InProductTrialsOverlayWindowReadyToTryType,
  InProductTrialsOverlayWindowTrialEndedType,
  InProductTrialsOverlayWindowTypesByGroupId,
} from '../../types/InProductTrialsOverlayWindowType';
import { InProductTrialsOverlayWindowDetails } from './InProductTrialsOverlayWindowDetails';

export interface InProductTrialsAdditionalUserSettings {
  dismissedInProductTrialsNewSectionPopup: boolean;
  shownInProductTrialsReadyToTryEndedPopups: Array<
    InProductTrialsOverlayWindowReadyToTryType | InProductTrialsOverlayWindowTrialEndedType
  >;
}

export namespace InProductTrialsAdditionalUserSettings {
  export function getAvailableInProductTrialsPopupsForGroupId(
    shownInProductTrialsReadyToTryEndedPopups: Array<
      InProductTrialsOverlayWindowReadyToTryType | InProductTrialsOverlayWindowTrialEndedType
    >,
    groupId: InProductTrialsOverlayWindowGroupId
  ): Array<InProductTrialsOverlayWindowDetails> {
    return shownInProductTrialsReadyToTryEndedPopups
      .filter(popup => InProductTrialsOverlayWindowTypesByGroupId[groupId].includes(popup))
      .map(popup => {
        return {
          type: popup,
          groupId: groupId,
        };
      });
  }
}
